import service from "../plugins/service"
import { createFormData } from '@/plugins/formData'

const base = '/equipmentServiceArchive/'

export const add = (o, fs) => {
  const data = createFormData(o)
  if (fs?.length) {
    fs.forEach(f => {
      data.append('files', f)
    })
  }

  return service({
    url: `${base}add`,
    method: 'POST',
    data
  })
}

export const update = (o, fs) => {
  const data = createFormData(o)
  if (fs?.length) {
    fs.forEach(f => {
      data.append('files', f)
    })
  }

  return service({
    url: `${base}update`,
    method: 'POST',
    data
  })
}

export const removeS = id => {
  return service({
    url: `${base}del/${id}`,
    method: 'POST'
  })
}

export const getList = (p, s, o) => {
  const data = createFormData(o)

  return service({
    url: `${base}list/${p}/${s}`,
    method: 'POST',
    data
  })
}

export const getRunTime = o => {
  const data = createFormData(o)

  return service({
    url: `${base}getRunTime`,
    method: 'POST',
    data
  })
}